



























































import { IStoreLink } from '@/store/modules/storelinks'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    MiniLoader: require('@/components/MiniLoader').default
  }
})
export default class ResultItem extends Vue {
  @Prop()
  data: IStoreLink
}
